// assets
import {
    SettingOutlined,
    TeamOutlined,
    ApiOutlined,
    FormOutlined,
    PhoneOutlined,
} from '@ant-design/icons';

import Permissions from 'constants/Permissions';

// ==============================|| MENU ITEMS - ADMIN ||============================== //

const administration = {
    id: 'administration-group',
    title: 'Admin',
    type: 'group',
    appModule: 'SYSTEM',
    children: [
        {
            id: 'user',
            title: 'Users',
            authority: Permissions.AdministrationSection.Users,
            type: 'item',
            url: 'administration/users',
            icon: TeamOutlined,
            breadcrumbs: false,
        },
        {
            id: 'api-services',
            title: 'Api Services',
            authority: Permissions.ApiServicesSection.ApiServices,
            type: 'item',
            url: '/api-services',
            icon: ApiOutlined,
        },
        {
            id: 'demo-requests',
            title: 'Demo Requests',
            authority: Permissions.AdministrationSection.Settings,
            type: 'item',
            url: '/administration/demo-requests',
            icon: FormOutlined,
            breadcrumbs: false,
        },
        {
            id: 'sales-requests',
            title: 'Sales Requests',
            authority: Permissions.AdministrationSection.Settings,
            type: 'item',
            url: '/administration/sales-requests',
            icon: PhoneOutlined,
            breadcrumbs: false,
        },
    ],
};

export default administration;
